import { useEffect, useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { Smartphone } from 'lucide-react'
import { mdmApi } from '../../../services/mdmApi'

/**
 * Miniatura da última captura de tela. O arquivo exige Bearer, então é baixado
 * como Blob e exibido via object URL (revogado ao desmontar/trocar).
 */
export default function ScreenshotThumb({ deviceId, fileId, className = '' }) {
  const { data: blob } = useQuery({
    queryKey: ['mdm-file-blob', deviceId, fileId],
    queryFn: () => mdmApi.downloadFile(deviceId, fileId),
    enabled: !!deviceId && !!fileId,
    staleTime: Infinity,
    retry: false,
  })
  const [url, setUrl] = useState(null)

  useEffect(() => {
    if (!blob) { setUrl(null); return undefined }
    const u = URL.createObjectURL(blob)
    setUrl(u)
    return () => URL.revokeObjectURL(u)
  }, [blob])

  if (!url) {
    return (
      <div className={`flex items-center justify-center bg-gray-100 text-gray-300 ${className}`}>
        <Smartphone className="w-8 h-8" />
      </div>
    )
  }
  return <img src={url} alt="Última captura de tela" className={`object-contain bg-black ${className}`} />
}
